import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { FULL_SCREEN_TOGGLE_PASSWORD } from "config/envConfig";
import { useState } from "react";
import { isTab } from "utils/helperFunctions";

export default function ToggleKioskPasswordPrompt({ onClose, onEditConfig }) {
  const [password, setPassword] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isTab() ? "calc(100% - 60px)" : "954px",
    maxHeight: "unset",
    overflowY: "unset",
    border: "none",
    borderRadius: "24px",
  };

  const handlePasswordSubmit = () => {
    if (password === FULL_SCREEN_TOGGLE_PASSWORD) {
      try {
        window.chrome?.webview?.postMessage("toggle-fullscreen");
      } catch (error) {
        console.error("Error toggling fullscreen:", error);
      }
      onClose();
    } else {
      alert("Incorrect Password");
    }
  };

  return (
    <Modal open onClose={onClose}>
      <Box sx={style}>
        <div className="bg-white p-6 md:p-12">
          <h2 className="text-2xl font-bold mb-4">Enter Kiosk Password</h2>
          <input
            type="password"
            className="w-full p-2 border border-gray-300 rounded mb-4"
            placeholder="Kiosk Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="flex justify-end">
            <button onClick={onClose} className="mr-4 px-4 py-2 rounded border">
              Cancel
            </button>
            <button
              onClick={() => {
                if (password === FULL_SCREEN_TOGGLE_PASSWORD) {
                  onClose();
                  onEditConfig?.();
                }
              }}
              className="mr-4 px-4 py-2 rounded border"
            >
              Edit Config
            </button>
            <button
              onClick={handlePasswordSubmit}
              className="bg-primary text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
